const theme = {
  plain: {
    backgroundColor: "transparent",
    color: "#223D7D",
  },
  styles: [
    {
      types: [
        "comment",
        "prolog",
        "doctype",
        "cdata",
        "punctuation",
        "operator",
      ],
      style: {
        color: "#888",
      },
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7,
      },
    },
    {
      types: ["tag", "number"],
      style: {
        color: "#F8B508",
      },
    },
    {
      types: ["property", "function"],
      style: {
        color: "#EF86B0",
      },
    },
    {
      types: ["tag-id", "selector", "atrule-id"],
      style: {
        color: "#C25C5C",
      },
    },
    {
      types: ["attr-name"],
      style: {
        color: "#7DDAA4",
      },
    },
    {
      types: [
        "keyword",
        "control",
        "directive",
        "unit",
        "statement",
        "regex",
        "at-rule",
        "placeholder",
        "variable",
      ],
      style: {
        color: "#C25C5C",
      },
    },
    {
      types: ["boolean", "string", "entity", "url", "attr-value"],
      style: {
        color: "#F8B508",
      },
    },
    {
      types: ["deleted"],
      style: {
        textDecorationLine: "line-through",
      },
    },
    {
      types: ["inserted"],
      style: {
        textDecorationLine: "underline",
      },
    },
    {
      types: ["italic"],
      style: {
        fontStyle: "italic",
      },
    },
    {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold",
      },
    },
    {
      types: ["important"],
      style: {
        color: "#C25C5C",
      },
    },
  ],
};

export default theme;
